import React from 'react';
import styled from 'styled-components';

import { useConfirmationModal } from 'components/basic/modal/ConfirmationModal';
import config from 'config';
import { invalidateNonceOnContract } from 'lib/ethereum/wallets/invalidateNonce';
import { waitAsync } from 'lib/promiseTools';
import { useSelector } from 'reduxState/store';

import type { DelegatedKeyAuthorization } from 'reduxState/delegatedKey/authorizationReducer';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50ch;
  width: 100%;
  line-height: normal;
  color: var(--gray4c);
  > div:first-of-type {
    padding-bottom: 10px;
  }
  > label {
    font-size: var(--medium);
    padding-bottom: 5px;
  }
`;

export function useInvalidateAllModal(
  currentDelegatedKey: DelegatedKeyAuthorization
) {
  const wallet = useSelector(state => state.wallet);

  return useConfirmationModal<{
    delegatedKey?: string;
  }>({
    confirmText: 'Invalidate All Session Keys',
    title: 'Invalidate All Session Keys',
    children: () => {
      return (
        <Wrapper>
          {!!currentDelegatedKey.walletAddress && (
            <>
              This will lock the current wallet and you will need to unlock your
              wallet again to proceed. All existing open orders are no longer
              valid and will be canceled.
              {/* TODO: link target */}
              {/* <Link href="#">Learn more about invalidation and removal.</Link> */}
              {/* TODO: [Contact support] to open live support widget */}
              {/* Contact support for help with XCHAIN gas. */}
            </>
          )}
        </Wrapper>
      );
    },
    confirmButtonProps: {
      color: 'red',
      bordered: true,
      autoFocus: true,
    },
    onConfirm: async (_, ctx) => {
      console.log('Start Invalidate');
      ctx.setConfirmText('Signature Required...');
      const contractAddress = config.chains.katanaChain.exchangeContract;
      const tx = await invalidateNonceOnContract(wallet, contractAddress);
      ctx.setConfirmText('Waiting for Confirmation...');
      await tx.wait();
      ctx.setConfirmText('Invalidation Complete');
      await waitAsync(3000);
      // User is not authenticated anymore, reload page
      window.location.reload();
    },
  });
}
